<app-dialog-header [title]="'Add Zone'" (closeClicked)="cancel()">
</app-dialog-header>

<div mat-dialog-content>
  <form [formGroup]="zoneForm">
    <div class="form-row">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Zone</mat-label>
        <mat-select formControlName="zone">
          @for (zone of data.zones; track zone) {
            <mat-option [value]="zone">
              {{ zone.name }}
            </mat-option>
          }
        </mat-select>
        @if (zoneForm.get("zone").hasError("required")) {
          <mat-error> Zone is required </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Start Date</mat-label>
        <input
          matInput
          [matDatepicker]="startPicker"
          formControlName="startDate"
          aria-label="Start date"
          placeholder="DD/MM/YYYY"
          data-lpignore="true"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="startPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>End Date</mat-label>
        <input
          matInput
          [matDatepicker]="endPicker"
          formControlName="endDate"
          aria-label="End date"
          placeholder="DD/MM/YYYY"
          data-lpignore="true"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="endPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Mapping Pattern</mat-label>
        <mat-select formControlName="mappingPattern">
          @for (pattern of data.mappingPatterns; track pattern) {
            <mat-option [value]="pattern">
              {{ pattern.description }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button
    mat-raised-button
    color="primary"
    [disabled]="!zoneForm.valid"
    (click)="saveZone()"
  >
    Save
  </button>
</div>
